import { importedproducts } from './imported-products-data';
import { importedretailers } from './imported-retailers-data';

export const importeddata = {
    'products': importedproducts,
    'retailers': importedretailers
};